// Package program (gói liệu trình nhiều buổi) trả về từ api/v1/package-program/list

export const PACKAGE_DISCOUNT_TYPE = {
  PERCENT: 'PERCENT',
  MONEY: 'MONEY',
} as const;

export interface IPackageProgramTier {
  id: string;
  name: string;
  /** số buổi của tier */
  quantity: number;
  discountType: keyof typeof PACKAGE_DISCOUNT_TYPE;
  discountValue: number;
  /** thứ tự hiển thị; theme Bronze/Silver/Gold gán theo vị trí sau khi sort */
  sortOrder: number;
  /** hang cua tier: BRONZE | SILVER | GOLD, quyet dinh mau the */
  type?: string;
  originalPrice: number;
  discountAmount: number;
  packagePrice: number;
  pricePerSession: number;
  saving: number;
  /** BE đang bổ sung theo từng tier; thiếu thì UI ẩn dòng thời hạn */
  validityMonths?: number | null;
}

export interface IPackageProgramItem {
  id: string;
  name: string;
  description: string;
  /** giá mỗi buổi */
  price: number;
  validityMonths: number;
  totalTier: number | null;
  enabled: boolean;
  tiers: IPackageProgramTier[];
}
